import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ConfigurationService from '../../../services/ConfigurationService';
import { translate, configs } from '../../../utils/util';
import { ENUMS, MODULES_CONFIGS } from '../../../utils/constants';
import * as configActions from '../../../actions/configAction';
import { Breadcrumbs, Input, SelectDock, SelectResource, SelectShed, SelectEquipment, SelectUnit, SelectPrintType, Card, ConfirmButtons } from '../../../components/UI/ComponentsUI';

const UserHome = (props) => {
    const [configsUser, setConfigs] = useState([]);

    useEffect(() => {
        props.configs({ moduleId: ENUMS.eModules.User.value }, (response) => {
            const items = MODULES_CONFIGS.User;

            if (response.items) {
                response.items.map((event) => {
                    for (let i = 0; i < items.length; i += 1) {
                        if (items[i].key === event.key) {
                            items[i].value = event.value;
                            items[i].configId = event.configId;
                        }
                    }
                    return event;
                });
            }
            setConfigs([...items]);
        });
        // eslint-disable-next-line
    }, []);

    const onConfirm = () => {
        props.configsPut(props.user.vision, configsUser, () => {
            props.setConfigUser(configs(ENUMS.eModules.User.value, configsUser));
            props.history.go(-1);
        });
    };

    const onChange = (event, index) => {
        const newArr = [...configsUser];
        if (event.target.type === 'checkbox') {
            newArr[index].value = (event.target.checked ? '1' : undefined);
        } else {
            newArr[index].value = event.target.value;
        }

        setConfigs(newArr);
    };

    const getShed = () => {
        if (configsUser && configsUser.length > 0) {
            var shed = configsUser.find((f) => f.key === 'shed');

            if (shed) {
                return shed.value;
            }
        }
    };

    const titleUser = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };
    const subtitlesUser = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-clipboard-check", label: translate('menu.user', 'configuration') }];
        return subtitlesItems;
    }

    const renderShed = (item, index) => {
        return (
            <SelectShed
                id={item.key}
                name={item.key}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}

            />);
    }

    const renderDock = (item, index) => {
        return (
            <SelectDock
                id={item.key}
                filterArea
                shedId={getShed()}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}

            />);
    }

    const renderResource = (item, index) => {
        return (
            <SelectResource
                id={item.key}
                filterArea
                shedId={getShed()}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}
            />)
    }

    const renderResourceLaser = (item, index) => {
        return (
            <SelectResource
                printLaser
                id={item.key}
                filterArea
                shedId={getShed()}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}
            />)
    }

    const renderEquipment = (item, index) => {
        return (
            <SelectEquipment
                id={item.key}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}
            />)
    }

    const renderUnit = (item, index) => {
        return (
            <SelectUnit
                id={item.key}
                shedId={getShed()}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}
            />);
    }

    const renderPrintType = (item, index) => {
        return (
            <SelectPrintType
                id={item.key}
                value={item.value}
                onChange={(evt) => onChange(evt, index)}
            />);
    }



    const renderDrop = (item, index) => {
        if (item.type === 'checkbox') {
            return (
                <Input
                    type={item.type}
                    key={item.key}
                    label={translate(item.label, 'configuration')}
                    id={item.key}
                    onClick={(evt) => onChange(evt, index)}
                    defaultChecked={Boolean(item.value || false)} />)
        }

        if (item.type === 'text') {
            return (
                <Input
                    type={item.type}
                    key={item.key}
                    label={translate(item.label, 'configuration')}
                    id={item.key}
                    onClick={(evt) => onChange(evt, index)}
                    value={item.value || ''} />)
        }

        if (item.type === 'drop') {
            if (item.key === 'shed') {
                return renderShed(item, index);
            }

            if (item.key === 'dock') {
                return renderDock(item, index);
            }

            if (item.key === 'resource') {
                return renderResource(item, index);
            }

            if (item.key === 'resourceLaser') {
                return renderResourceLaser(item, index);
            }

            if (item.key === 'equipment') {
                return renderEquipment(item, index);
            }

            if (item.key === 'unitId') {
                return renderUnit(item, index);
            }

            if (item.key === 'print') {
                return renderPrintType(item, index);
            }
        }
    }

    return (
        <div>
            <Breadcrumbs id="userHome" title={titleUser} subtitles={subtitlesUser()} />
            {
                configsUser && configsUser.length > 0 && (
                    <div className="container-fluid" style={{ marginTop: '25px', }}>
                        <div className="container">
                            <Card>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    {
                                        configsUser.map((item, index) => (
                                            <div key={item.key} className="input-field no-padding col s12">
                                                {
                                                    renderDrop(item, index)
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                                <ConfirmButtons
                                    onConfirm={onConfirm}
                                    onCancel={() => props.history.goBack()} />
                            </Card>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        warehouses: state.configReducer.warehouses,
        docks: state.configReducer.docks,
        sheds: state.configReducer.shedsUnload,
        resources: state.logisticsResourceReducer.list,
        resource: state.configReducer.resource,
        shed: state.configReducer.shed,
        dock: state.configReducer.dock
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        configs: (filter, callback) => {
            dispatch(ConfigurationService.getConfigs(filter, callback));
        },
        configsPut: (vision, data, callback) => {
            dispatch(ConfigurationService.putConfig(vision, data, callback));
        },
        setConfigUser: (config) => {
            dispatch(configActions.setConfigsUser(config));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserHome)));
